import common from './common'

export default {
  init() {
    $('main[data-barba=container]').imagesLoaded(() => {
      // 記事中の画像 ----------------
      $('section.content .wp-block-image img').each(function () {
        const el = $(this)
        // width <= height の画像
        if(el.width() <= el.height()) {
          el.wrap('<div class="portrait"></div>')
        }
      })
    })
    common.enableMultipleLineBorderheading('section.content')

    // リサイズ処理
    const resizeIframeWithKeepingAspectRatio = function () {
      $('section.content iframe').each(function () {
        const me = $(this)
        if (/(youtube\.com|vimeo\.com)/.test(me.attr('src'))) {
          const height = me.width() * (me.attr('height') / me.attr('width'))
          me.css('height', `${height}px`)
        }
      })
    }
    $(window).on('resize', resizeIframeWithKeepingAspectRatio)
    setTimeout(resizeIframeWithKeepingAspectRatio, 1)
  }
}
